class ModelSizeSelector extends HTMLElement {
  constructor() {
    super();
    this.$selectedModelSize = this.querySelector('.model-size__selected');
    this.$arrow = this.querySelector('.model-size__arrow');
    this.$modelSizeOptions = this.querySelector('.model-size__options');
    this.modelSizeOptions = JSON.parse(
      this.querySelector('[data-model-size-options]').innerHTML
    );
    this.$selectedProductSlide = document.querySelector('.product__slides')
      ? document
          .querySelector('.product__slides')
          .querySelector('.product__slide.is-selected')
      : null;
    this.productSlides = this.querySelector('[data-product-medias]')
      ? JSON.parse(this.querySelector('[data-product-medias]').innerHTML)
      : null;
    if (this.productSlides && this.productSlides.medias) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.productSlides.medias;
      this.$productSlides = tempDiv.querySelectorAll('.product__slide');
    }

    this.$productSlideshow = this.closest('.product__slides');

    this.selectedModelSize = this.getModelSize();

    if (this.querySelector('[data-collection-json]')) {
      this.jsonData = JSON.parse(
        this.querySelector('[data-collection-json]').innerHTML
      );

      this.products = this.jsonData.products;
    } else {
      this.products = [];
      this.jsonData = JSON.parse(
        this.querySelector('[data-product-json]').innerHTML
      );
      this.product = this.jsonData;
      this.$modelSizeDescriptions = document.querySelectorAll(
        `.model-size__description[data-model-size-product="${this.product.handle}"]`
      );
      this.$modelSizeDescriptionsDefault = document.querySelectorAll(
        `.model-size__description--default[data-model-size-product="${this.product.handle}"]`
      );
    }

    this.init();
  }

  init() {
    // Set initial value
    if (
      this.selectedModelSize == null ||
      !this.modelSizeOptions.includes(this.selectedModelSize)
    ) {
      const initialModelSize =
        this.$selectedModelSize.dataset.sizeOption == 'all'
          ? 'all'
          : this.$selectedModelSize
              .querySelector('.value')
              .innerHTML.split(',')
              .pop()
              .trim()
              .toLowerCase();

      this.setModelSize(initialModelSize);
    } else {
      this.setModelSize(this.selectedModelSize);
    }

    window.onload = () => {
      //Initialise product cards
      this.updateProductCards();
    };

    //Initialise product slideshow
    this.onProductSlideshowInitialised();

    // Toggle options list
    this.$selectedModelSize.addEventListener('click', () => {
      this.toggleOptions();
    });

    // Handle option selection
    this.$modelSizeOptions
      .querySelectorAll('.model-size__option')
      .forEach((option) => {
        option.addEventListener('click', (event) => {
          const isShowAll = event.currentTarget.dataset.sizeOption === 'all';
          this.$selectedModelSize.querySelector('.value').innerHTML =
            event.currentTarget.textContent;
          if (isShowAll) {
            this.setModelSize('all');
          } else {
            this.setModelSize(
              event.currentTarget.textContent
                .split(',')
                .pop()
                .trim()
                .toLowerCase()
            );
          }

          this.hideOptions();
          this.updateProductCards();
          this.updateProductSlideshow();
          this.updateModelSizeDescription();
        });
      });

    // Close the selector if clicked outside
    document.addEventListener('click', (event) => {
      var isClickInside =
        this.$selectedModelSize.contains(event.target) ||
        this.$modelSizeOptions.contains(event.target);

      if (!isClickInside) {
        this.hideOptions();
      }
    });
  }

  onProductSlideshowInitialised() {
    if (this.$productSlideshow) {
      this.$productSlideshow.addEventListener('created', (event) => {
        this.updateProductSlideshow();
      });
    }
  }

  updateProductSlideshow() {
    this.$productSlideshow = this.closest('.product__slides');
    let $selectedProductSlides = [];

    if (!this.$productSlideshow || !this.$productSlides) return;

    if (this.selectedModelSize === 'all') {
      $selectedProductSlides = Array.from(this.$productSlides).map((slide) => {
        return slide.outerHTML;
      });
    } else {
      $selectedProductSlides = Array.from(this.$productSlides)
        .filter((slide) => {
          const alt = slide.dataset.mediaAlt
            .split(',')
            .pop()
            .trim()
            .toLowerCase();
          return alt === this.selectedModelSize;
        })
        .map((slide) => {
          return slide.outerHTML;
        });
    }

    this.$productSlideshow.dispatchEvent(
      new CustomEvent('reload', {
        detail: {
          slides: $selectedProductSlides,
        },
      })
    );

    this.updateModelSizeDescription();
    this.classList.remove('is-hidden');
  }

  updateModelSizeDescription() {
    if (!this.$modelSizeDescriptions) return;

    this.$modelSizeDescriptions.forEach((description) => {
      description.classList.remove('is-selected');
      const size = this.getSizeFromLabel(description.dataset.modelSizeLabel);
      if (size === this.selectedModelSize) {
        description.classList.add('is-selected');
      }
    });
  }

  updateProductCards() {
    document.querySelectorAll('.product-item').forEach((productCard) => {
      this.updateProductCard(productCard);
    });
  }

  toggleOptions() {
    this.$modelSizeOptions.classList.toggle('is-active');
    this.$arrow.classList.toggle('is-active');
  }

  showOptions() {
    this.$modelSizeOptions.classList.add('is-active');
    this.$arrow.classList.add('is-active');
  }

  hideOptions() {
    this.$modelSizeOptions.classList.remove('is-active');
    this.$arrow.classList.remove('is-active');
  }

  async fetchProductData(handle) {
    const response = await fetch(`/products/${handle}.js`);
    const data = await response.json();
    return data;
  }

  setModelSize(size) {
    localStorage.setItem('model_size', size);
    this.selectedModelSize = size;
    this.$modelSizeOptions
      .querySelectorAll('.model-size__option')
      .forEach((option) => {
        option.classList.remove('is-active');
      });

    this.$modelSizeOptions
      .querySelectorAll('.model-size__option')
      .forEach((option) => {
        const label = option.querySelector('.value').innerHTML;
        let size = option
          .querySelector('.value')
          .innerHTML.split(',')
          .pop()
          .trim()
          .toLowerCase();
        const isShowAll = option.dataset.sizeOption === 'all';
        if (isShowAll) {
          size = 'all';
        }

        if (size === this.selectedModelSize) {
          this.$selectedModelSize.querySelector('.value').innerHTML = label;
          option.classList.add('is-active');
        }
      });
  }

  getModelSize() {
    return localStorage.getItem('model_size');
  }

  getSizeFromLabel(label) {
    return label.split(',').pop().trim().toLowerCase();
  }

  getSelectedModelSizeImage(product) {
    const selectedImage = product.media.find(
      (m) =>
        m.alt &&
        m.alt.toLowerCase().split(',').pop().trim() === this.selectedModelSize
    );
    return selectedImage;
  }

  async updateProductCard(productCard) {
    // const selectedModelSize = this.getModelSize();
    const handle = productCard.dataset.handle;

    let product = this.products.find((product) => product.handle === handle);
    const productLink = productCard.querySelector('.product-link');
    const backgroundImageDiv = productCard.querySelector('.product-item__bg');

    // The limit of products rendering from .liquid is limited to 50. So if a collection has more than 50 products, the rest of the products will be fetched from the AJAX API
    if (!product) {
      if (handle) {
        product = await this.fetchProductData(handle);
        this.products.push(product);
      }
    }

    if (product) {
      const selectedImage = this.getSelectedModelSizeImage(product);

      const variant = product.variants.find(
        (variant) =>
          variant.option1.toLowerCase() === this.selectedModelSize.toLowerCase()
      );
      if (selectedImage) {
        backgroundImageDiv.style.backgroundImage = `url('${selectedImage.src}')`;
      } else {
        backgroundImageDiv.style.backgroundImage = `url('${product.featured_image}')`;
      }

      if (variant) {
        // Update the product link href to include the variant id so customer is directed straight to the correct variant
        productLink.href =
          window.origin +
          '/products/' +
          product.handle +
          '?variant=' +
          variant.id;
      } else {
        productLink.href = window.origin + '/products/' + product.handle;
      }
    } else {
      console.log('no product found', handle);
    }
  }

  /**
   * Observes DOM mutations on a specified target element and performs actions based on those mutations.
   * @param {Element} target - The DOM element to observe for mutations.
   * @returns {MutationObserver|null} A MutationObserver instance or null if the target is invalid.
   */
  async mutationObserver(target) {
    // Validate the target to ensure it's a DOM element.
    if (!(target instanceof Element)) {
      console.error('Invalid target element provided');
      return null;
    }

    // Define the configuration for the observer: observe child list and subtree mutations.
    const config = { childList: true, subtree: true };

    // Define the callback to execute when mutations are observed.
    const callback = async (mutationList) => {
      for (const mutation of mutationList) {
        // Process only 'childList' type mutations.
        if (mutation.type === 'childList') {
          for (const node of mutation.addedNodes) {
            if (!(node instanceof Element)) {
              return null;
            }

            // Check if the node is a product item, then update it.
            if (node.classList && node.classList.contains('product-item')) {
              await this.updateProductCard(node, true);
            } else {
              // Check for product items within the node and update each.
              const productItems = node.querySelectorAll('.product-item');
              if (productItems.length > 0) {
                this.mutationObserver(node);
                for (const productItem of productItems) {
                  await this.updateProductCard(productItem, true);
                }
              }
            }
          }
        }
      }
    };

    // Create an observer instance linked to the callback function.
    const observer = new MutationObserver(callback);

    // Start observing the target node for the specified mutations.
    observer.observe(target, config);

    // Return the observer instance for external control.
    return observer;
  }
}

customElements.define('model-size-selector', ModelSizeSelector);
